<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar w-p-100 flex flex-row justify-start items-center">
    <button class="mr-sm-16 mat-icon-button back-btn" mat-icon-button="" tabindex="0" (click)="back()">
      <mat-icon class="mat-icon ng-tns-c39-36 material-icons" role="img"
                aria-hidden="true">arrow_back
      </mat-icon>
    </button>

    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="addSolution()" [disabled]="user === null"
                  particleAnalytics
                  analyticsCategory="projects-content"
                  analyticsAction="add project">Add Solution
          </button>

          <div class="toolbar-separator"></div>
        </div>

        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="cloneUser()" [disabled]="user === null"
                  particleAnalytics
                  analyticsCategory="projects-content"
                  analyticsAction="add project">Clone User
          </button>

          <div class="toolbar-separator"></div>
        </div>

        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="sendPassword()" [disabled]="user === null"
                  particleAnalytics
                  analyticsCategory="projects-content"
                  analyticsAction="delete project">Send Password
          </button>

          <div class="toolbar-separator"></div>
        </div>

        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="createSupportTicket()"
                  [disabled]="user === null"
                  particleAnalytics
                  analyticsCategory="projects-content"
                  analyticsAction="delete project">Create Support Ticket
          </button>

          <div class="toolbar-separator"></div>
        </div>

      </div>
    </div>

  </div>
  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg parent-tab-for-grid">
        <mat-tab-group [selectedIndex]="selectedTabIndex">
          <mat-tab label="User Details">
            <form class="p-30 flex flex-col" *ngIf="detailForm" [formGroup]="detailForm">
              <div class="flex flex-col">

                <div class="flex flex-row justify-start items-start auto-flex"
                     *ngIf="isEditing.firstName === false">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="firstName" (click)="editFirstName()"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <particle-inplace-input *ngIf="isEditing.firstName === true"
                                        [text]="detailForm.value.firstName"
                                        placeHolder="First Name"
                                        (valueChanged)="updateFirstName($event)"
                                        (cancelled)='resetEditing()'>
                </particle-inplace-input>

                <div class="flex flex-row justify-start items-start auto-flex"
                     *ngIf="isEditing.lastName === false">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="lastName" (click)="editLastName()"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <particle-inplace-input *ngIf="isEditing.lastName === true"
                                        [text]="detailForm.value.lastName"
                                        placeHolder="Last Name"
                                        (valueChanged)="updateLastName($event)"
                                        (cancelled)='resetEditing()'>
                </particle-inplace-input>

                <div class="flex flex-row justify-start items-start auto-flex">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Company Name</mat-label>
                    <input matInput formControlName="companyName"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <div class="flex flex-row justify-start items-start auto-flex">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Designation</mat-label>
                    <input matInput formControlName="designation"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <div class="flex flex-row justify-start items-start auto-flex">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <div class="flex flex-row justify-start items-start auto-flex"
                     *ngIf="isEditing.userNote === false">
                  <mat-form-field appearance="outline" class="flex-1-1-50">
                    <mat-label>Notes</mat-label>
                    <input matInput formControlName="userNote" (click)="editUserNote()"
                           particleAnalytics
                           analyticsCategory="account-settings"
                           analyticsAction="password-input">
                  </mat-form-field>
                </div>

                <particle-inplace-input *ngIf="isEditing.userNote === true"
                                        [text]="detailForm.value.userNote"
                                        placeHolder="Notes"
                                        (valueChanged)="updateUserNote($event)"
                                        (cancelled)='resetEditing()'>
                </particle-inplace-input>

                <div class="flex flex-row justify-start items-start auto-flex">
                  <mat-checkbox formControlName="isActive" (change)="updateUserData()">Is Active
                  </mat-checkbox>
                </div>

              </div>
            </form>
          </mat-tab>
          <mat-tab label="Package Lists">
            <div class="w-p-100 h-p-100 p-30">
              <div class="pos-relative full-grow-no-shrink-no-basis">
                <div class="keno-grid-container">
                  <particle-smart-grid [sourceType]="sourceType"
                                       (valueChanged)="onValueChanged($event)"
                                       [selectableSettings]="selectableSettings"
                                       [pageable]="pageable">
                  </particle-smart-grid>
                </div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </mat-sidenav-container>
</div>
